module.exports = __webpack_public_path__ + "img/b_22.8b300656.jpg";